import React, { useState, useRef } from "react";
import "./About.css";
import about_us_logo from "../../assets/aboutpage/about_us_logo.png";
import hive_page_logo from "../../assets/allpages/hive_page_logo.png";
import who_we_are_nav from "../../assets/aboutpage/about_nav/whoweare.png";
import AboutTextes from "./AboutTextes"; // Importing the text config file
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SEOHelmet from "../SEOHelmet";
import {
  faChevronRight,
  faChevronLeft,
} from "@fortawesome/free-solid-svg-icons";

const About = () => {
  const [selectedSection, setSelectedSection] = useState("who_we_are_about");

  const aboutRef = useRef(null);
  const leftTopRef = useRef(null);
  const rightLogoRef = useRef(null);
  const leftCenterRef = useRef(null);
  const rightCenterRef = useRef(null);

  const handleNavClick = (id) => {
    setSelectedSection(id);
  };

  return (
    <>
      <SEOHelmet
        title="Despre HiveTeam - Echipa de Web Development si Branding"
        description="Afla povestea HiveTeam, echipa care dezvolta website-uri moderne si identitati de brand pentru companii din Romania, inclusiv firme de design interior, amenajari interioare si arhitectura."
        keywords="despre hiveteam, echipa web development romania, branding design interior, site pentru amenajari interioare, pradais samuel"
        canonicalUrl="https://hiveteam.dev/"
      />
      <div className="about_page" id="about" ref={aboutRef}>
        <div className="about_container">
          <div className="about_top">
            <div className="left_about_top" ref={leftTopRef}>
              <img src={about_us_logo} alt="About HiveTeam" />
              <p>
                Our team is a dynamic and diverse group of talented
                professionals who each bring a unique set of skills and
                experiences. Below is a detailed description of each team
                member:
              </p>
            </div>
            <img
              className="hive_allpages"
              src={hive_page_logo}
              alt="HiveTeam logo"
              ref={rightLogoRef}
            />
          </div>

          <div className="about_center">
            <div className="left_about_center" ref={leftCenterRef}>
              <div className="top_left_about_center">
                <div className="text_left_about_center">
                  <h1>{AboutTextes[selectedSection].title}</h1>
                  <div className="liniegradient"></div>
                </div>

                <div className="pathforms_top_about_center">
                  <div className="left_pathfroms">
                    <div className="circles_forms">
                      <div className="circle"></div>
                      <div className="circle"></div>
                      <div className="circle"></div>
                    </div>
                    <div className="arrow_path">
                      <FontAwesomeIcon
                        className="icon_about"
                        icon={faChevronLeft}
                      />
                      <FontAwesomeIcon
                        className="icon_about"
                        icon={faChevronRight}
                      />
                    </div>
                    <div className="rectangled_squred">
                      <div className="smaller_rectangled_squred"></div>
                    </div>
                  </div>
                  <div className="right_pathforms">
                    <div className="rectangled"></div>
                    <div className="rectangled"></div>
                    <div className="rectangled"></div>
                  </div>
                </div>
              </div>

              <div
                className="text_cont"
                dangerouslySetInnerHTML={{
                  __html: AboutTextes[selectedSection].content,
                }}
              />
            </div>
            <div className="right_about_center" ref={rightCenterRef}>
              {Object.keys(AboutTextes).map((key) => (
                <button
                  type="button"
                  key={key}
                  id={key}
                  aria-label={`Open ${AboutTextes[key].title}`}
                  className={`right_about_nav_button ${selectedSection === key ? "selected_right_about_nav" : ""}`}
                  onClick={() => handleNavClick(key)}
                >
                  <img src={who_we_are_nav} alt="" aria-hidden="true" />
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
